// extracted by css-extract-rspack-plugin
export default {"tabs":"tabs-dTN7Vp","tab":"tab-purROc"};